@if (showLabel) {
  <div class="fx--h fx--label fx--label__nowrap fx--mb-4 fx--label__bold fx--juc-space-between">
    <label class="miq-form-input-label" [attr.for]="filter$().key">{{ filter$().value }}</label>
  </div>
}
<div class="form-field__container">
  <p-multiSelect
    class="primeng-multiselect"
    [options]="options"
    [appendTo]="'body'"
    placeholder="All"
    maxSelectedLabels="1"
    selectedItemsLabel="{0} Selected Items"
    panelStyleClass="filter-multi-select"
    [formControl]="control"
    [resetFilterOnHide]="true"
    [showClear]="hasClearIcon"
    (onChange)="handleChange()"
    >
    <ng-template pTemplate="clearicon">
      <em class="multiselect-clear pi pi-times-circle" (click)="control.setValue(null)"></em>
    </ng-template>
  </p-multiSelect>
</div>
